// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 67176, offsets 199836:200042. Structure and names inferred from code, not screenshots.

import { module5969 as dependency5969 } from "../vendor/dependencies.js";
import { module11474 as dependency11474 } from "../vendor/dependencies.js";
import * as dependency5975 from "./getLanguage.js";
import { module79457 as n } from "../vendor/dependencies.js";
import { interopDefault } from "../vendor/runtime.js";
var o = interopDefault(n);
function setDateLocale(e) {
  "zh" === e ? o().locale("zh-cn") : o().locale("en");
}
(dependency5969,
  dependency11474,
  setDateLocale((0, dependency5975.getLanguage)()));
const dayjs = o.a;
export { dayjs, setDateLocale };
